<template>
  <div class="d-flex flex-column" style="position: relative; width: 100%">
    <div class="mb-2" v-if="label || titleValue">
      <label class="text-caption grey--text">{{ $t(titleValue) }}</label>
    </div>

    <v-list dense>
      <v-list-item v-for="item in sortOptions" :key="item[valueField]" :disabled="itemDisabled(item)" @click="toggle(item)">
        <v-list-item-action>
          <v-checkbox v-if="returnObject" :input-value="v.some(el => el[valueField] === item[valueField])" :disabled="itemDisabled(item)" @click.stop="toggle(item)" />
          <v-checkbox v-else :input-value="v.includes(item[valueField])" :disabled="itemDisabled(item)" @click.stop="toggle(item)" />
        </v-list-item-action>

        <v-list-item-content>
          <v-list-item-title>
            {{ item[textField] }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <!-- стандартная ошибка -->
    <div v-if="error" class="error-text red--text text-caption mt-1">
      {{ error }}
    </div>
  </div>
</template>

<script>
import modelOptions from "../../libs/modelOptions";

export default {
  mixins: [modelOptions],
  props: {
    value: [String, Number, Array, Boolean],
    values: {
      type: Object,
      default: () => {
        return {};
      },
    },

    model: Object,
    label: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: "",
    },
    config: { type: Object, default: {}, disabled: false },
  },
  data() {
    return {
      listDisabled: [],
      cc: 0,
      showAllItem: false,
      title: null,
      preText: null,
      toggleSelect: false,
    };
  },
  computed: {
    returnObject() {
      return !!this.model?.returnObject;
    },
    v: {
      get() {
        let res = this.value;
        if (this.model.chips) {
          if (res === null || res === undefined) res = [];
          if (this.model.keyInObject) {
            res = (this.value || []).map(v => v[this.model.keyInObject]);
          }
          if (!Array.isArray(res))
            try {
              res = res.split(",");
            } catch (error) {
              res = [res];
            }
        }
        return res;
      },
      set(v) {
        let res = v;
        if (this.model.keyInObject) {
          res = [
            ...v.map(e => {
              return { [this.model.keyInObject]: e };
            }),
          ];
        }
        this.onInput(res);
        //this.$emit("input", res);
      },
    },
    textField() {
      return this.model.textField || "text";
    },

    valueField() {
      return this.model?.itemField?.value || "value";
    },
    options() {
      const res = this.getOptions(this.model);
      this.listDisabled = [];
      if (!res) return [];
      if (Array.isArray(res)) {
        res.forEach(e => {
          if (e?.isActive === undefined && typeof e === "object") {
            e.isActive = !this.checkDisabled(e);
          }
        });

        if (res) {
          const resE = res.filter(r => r.isActive);
          const resD = res.filter(r => !r.isActive);
          this.listDisabled = [...resD];
          return resE;
        }
      }
      return [];
    },
    sortOptions() {
      let model = this.model;
      let list = JSON.parse(JSON.stringify(this.options));
      if (model?.dirVar) {
        const key = model.dirVar.key;
        if (this.values) {
          const v = model?.json ? this.values?.data?.[key] : this.values[key];
          const name = model.dirVar.dirName.find(el => {
            return el.value == v;
          });
          this.title = name?.title || null;
          this.preText = name?.preText || null;
        }
      }
      if (this.value && !list.some(list => list.value === this.value) && !Array.isArray(this.value)) {
        list = [{ text: this.value, value: this.value }, ...list];
      }
      return list.sort((a, b) => {
        return (a.text > b.text) - (a.text < b.text);
      });
    },
    readonly() {
      if (this.config?.readonly || this.model?.readonly) return true;
      return false;
    },
    titleValue() {
      return this.title || this.model.title;
    },
  },
  methods: {
    toggle(item) {
      if (this.disabled || this.readonly) return;

      // создаём копию массива
      const arr = [...this.v];

      // если работаем с объектами
      if (this.returnObject) {
        // ищем по значению ключа, а не по ссылке!
        const idx = arr.findIndex(el => {
          return this.valueField ? el[this.valueField] === item[this.valueField] : JSON.stringify(el) === JSON.stringify(item); // fallback
        });

        if (idx === -1) {
          arr.push(item);
        } else {
          arr.splice(idx, 1);
        }

        this.v = arr;
        return;
      }

      // --- иначе работаем как раньше со значениями ---
      const value = item[this.valueField];

      const idx = arr.indexOf(value);
      if (idx === -1) arr.push(value);
      else arr.splice(idx, 1);

      this.v = arr;
    },
    onKeyDown(e) {
      if (e.key === "*") {
        console.log("*");
        this.showAllItem = !this.showAllItem;
        e.preventDefault();
      }
    },
    itemDisabled(e) {
      if (typeof e === "string") return false;
      return !e.isActive;
    },
    checkDisabled(e) {
      if (this.showAllItem) return false;
      if (this.model.isActiveFunc) {
        try {
          const f = eval(`(d)=>{return ${this.model.isActiveFunc}}`);
          return !f(e);
        } catch (error) {
          console.error("Error isActive", error);
        }
      }
      if (e?.isActive === false || e.hidden || e?.disabled === true) return true;
      return false;
    },
    sendData(v) {
      console.log("sssssssss", v);
      let selected = this.options.find(d => d?.[this.valueField] == v);
      if (selected) {
        this.$emit("fieldData", selected);
      }
      this.$emit("selected", selected);
    },
    onInput(e) {
      this.$emit("input", e);
      if (this.model?.cascade) {
        for (const key in this.model.cascade) {
          const el = this.model.cascade[key];
          if (el.type == "field") {
            let value = this.options.find(f => f["value"] == e)?.[el.value];
            if (value !== undefined) {
              //this.$emit("cascade", { field: el.value, value });
              console.log("cascade ", { field: key, value });
              this.$emit("cascade", { field: key, value });
            }
          }
          if (el.type == "formula") {
            let func;
            let f = this.options.find(f => f["value"] == e)?.[el.value];
            if (typeof f == "string") func = eval(f);
            let value = func(this.values);
            if (value !== undefined) {
              this.$emit("cascade", { field: key, value });
            }
          }
        }
      }
      this.sendData(e);
    },
  },
};
</script>
<style lang="scss" scoped></style>
